// Copyright (c) StrangeBee 2024

import React, { ReactElement, useCallback, useEffect } from 'react';
import { operatorSignLabel } from '@Constants/filters';
import { THAutoComplete } from '@Molecules/Inputs/THAutoComplete/THAutoComplete';

export interface DescribeFieldOutput {
    label: string;
    attributes: DescribeFieldAttribute[];
}
export interface DescribeFieldAttribute {
    name: string;
    type: 'string' | 'enumeration' | 'number' | 'user' | 'boolean' | 'date' | 'url';
    values: string[];
    labels: string[];
    description: string;
}

interface FiltersOperatorProps {
    describeField?: DescribeFieldOutput;
    operator?: string;
    onChange?: (value: string) => void;
    fieldName?: string;
}

const FiltersOperator = ({
    describeField,
    operator = '',
    onChange,
    fieldName = '',
}: FiltersOperatorProps): ReactElement | null => {
    const fieldAttributes = describeField?.attributes.find((attribute) => attribute.name === fieldName);

    const { values, type = 'string' } = fieldAttributes || {};

    const fieldType = values?.length !== 0 && type === 'number' ? 'enumeration' : type;

    const resetOperatorValue = useCallback(() => {
        if (fieldName && fieldType && !operator) {
            onChange?.(operatorSignLabel[fieldType][0].value);
        }
    }, [fieldName, fieldType, operator, onChange]);

    useEffect(() => {
        resetOperatorValue();
    }, [fieldName, resetOperatorValue]);

    return (
        <div className="operator">
            <THAutoComplete
                showSearch
                options={operatorSignLabel[fieldType].map(({ label, value }) => ({ label, value }))}
                value={operator}
                onChange={onChange}
                className="input-full-width"
            />
        </div>
    );
};

export default FiltersOperator;
